import { createAsyncActionType } from './index';

export const NOTIFICATION_GET = createAsyncActionType(
  'notification',
  'NOTIFICATION_GET'
);
export const NOTIFICATION_READ = createAsyncActionType(
  'notification',
  'NOTIFICATION_READ'
);
export const NOTIFICATION_DELETE = createAsyncActionType(
  'notification',
  'NOTIFICATION_DELETE'
);
export const SITE_NOTIFICATION_TOGGLE = createAsyncActionType(
  'notification',
  'SITE_NOTIFICATION_TOGGLE'
);
export const NOTIFICATION_DETAILS_GET = createAsyncActionType(
  'notification',
  'NOTIFICATION_DETAILS_GET'
);

export const NOTIFICATION_DETAILS_RESET =
  '@@notification/NOTIFICATION_DETAILS_RESET';
